import { Component, OnDestroy } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster';
import { RouterOutlet } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from 'shared-stuff';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { slider } from './slider'
import { BreakpointObserver } from '@angular/cdk/layout';
import { Idle } from 'idlejs/dist';
import { AuthService } from 'app/core/auth.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  styleUrls: ['../../../scss/vendors/toastr/toastr.scss'],
  animations: [slider]
})
export class FullLayoutComponent implements OnDestroy {
  idle: Idle;
  currentUser$: Observable<any>
  currentUserId: string = '';
  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });
  constructor(
    private db: AngularFirestore,
    private breakpointObserver: BreakpointObserver,
    private auth: AuthService
  ) {
    //needed to detect viewport changes
    this.breakpointObserver.observe(['(min-width: 599px)']).subscribe();

    // idle detection
    this.idle = new Idle()
      .whenNotInteractive()
      .within(20) // in minutes
      .do(() => this.auth.signOut())
      .start();
  }


  public prepareRoute(outlet: RouterOutlet) {
    const newId: string = outlet.activatedRoute.snapshot.params['id']
    if (this.currentUserId != newId) {
      this.currentUserId = newId;
      this.currentUser$ = this.db.collection('users').doc<User>(this.currentUserId).valueChanges().pipe(
        retry() // retry needed for permission errors after sign up
      )
    }
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['title'];
  }

  public smallScreen(): boolean {
    return this.breakpointObserver.isMatched('(max-width: 599px)')
  }

  ngOnDestroy() {
    this.idle.stop();
  }
}


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/full-layout/full-layout.component.ts